module.exports = __webpack_public_path__ + "img/ps-55.26f63b4f.jpg";